import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '@pattern-library/buttons';
import { selectRowColumn, expandRowColumn } from '../utils/columnHelpers';
import { ChevronDownBoldIcon, ChevronUpBoldIcon } from '@pattern-library/icon';
const propTypes = {
  /**
   * The columns to be displayed in the row
   */
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * The data object to be displayed in the row
   */
  data: PropTypes.object.isRequired,
  /**
   * Function to apply custom classes to the row. The function will be called
   * with the row data object and should return a string of classes to be
   * applied to the row.
   * (data: object) => string
   */
  getRowClass: PropTypes.func,
  /**
   * whether the row is selected
   */
  isSelected: PropTypes.bool,
  /**
   * Function to handle the select row event
   */
  onToggleSelectRow: PropTypes.func,
  /**
   * The unique identifier for the row
   */
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
export default class GridListRow extends Component {
  constructor(props) {
    super(props);
    this.toggleExpandDetails = () => {
      this.setState(state => ({
        isExpanded: !state.isExpanded
      }));
    };
    this.state = {
      isExpanded: false
    };
  }
  getRowClassName() {
    const {
      getRowClass,
      data
    } = this.props;
    const {
      isExpanded
    } = this.state;
    return cx('asc-grid-row', getRowClass && getRowClass(data), isExpanded && 'is-open');
  }
  getCellClassName(column) {
    const {
      data
    } = this.props;
    return cx('asc-grid-row-item', column.getCellClass && column.getCellClass(data), {
      'asc-text--right': column.textAlign === 'right',
      'asc-text--center': column.textAlign === 'center'
    });
  }
  getInlineStylesForCell(column) {
    const styles = {};
    if (column.width) {
      styles.width = column.width;
      styles.maxWidth = column.width;
    } else if (column.minWidth) {
      styles.flexBasis = column.minWidth;
    }
    return styles;
  }
  getCellContent(column) {
    const {
      data
    } = this.props;
    if (column.cell) {
      return typeof column.cell === 'function' ? column.cell(data) : column.cell;
    }
    return data[column.dataKey];
  }
  getExpandedContent() {
    const {
      columns,
      data,
      rowId
    } = this.props;
    const expandableColumn = columns.find(column => expandRowColumn.isExpandRowColumn(column));
    const content = typeof expandableColumn.content === 'function' ? expandableColumn.content(data) : expandableColumn.content;
    return /*#__PURE__*/React.createElement("div", {
      id: `${rowId}-content`,
      className: "asc-grid-row-details"
    }, content);
  }
  render() {
    const {
      data,
      rowId,
      columns,
      isSelected,
      onToggleSelectRow
    } = this.props;
    return /*#__PURE__*/React.createElement("li", {
      className: this.getRowClassName(),
      role: "row",
      "data-qa": "grid-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "asc-grid-row-cells"
    }, columns.map(column => {
      if (selectRowColumn.isSelectRowColumn(column)) {
        return /*#__PURE__*/React.createElement("div", {
          key: column.dataKey,
          className: "asc-grid-row-item asc-grid-row-item--select"
        }, /*#__PURE__*/React.createElement("div", {
          className: "asc-checkbox-group"
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: rowId,
          name: rowId,
          value: rowId,
          checked: isSelected,
          onChange: event => onToggleSelectRow(rowId, event.target.checked)
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: rowId,
          className: "asc-form-label"
        }, /*#__PURE__*/React.createElement("span", {
          className: "asc-acc-hidden"
        }, "Select To Add"))));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: this.getCellClassName(column),
        role: "cell",
        key: column.dataKey,
        "data-qa": column.header,
        style: this.getInlineStylesForCell(column)
      }, !expandRowColumn.isExpandRowColumn(column) && this.getCellContent(column), expandRowColumn.isExpandRowColumn(column) && expandRowColumn.hasContent(column, data) && /*#__PURE__*/React.createElement(Button, {
        type: "button",
        text: this.state.isExpanded ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChevronUpBoldIcon, {
          color: "current"
        }), /*#__PURE__*/React.createElement("span", {
          className: "asc-acc-hidden"
        }, "Collapse expanded content")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChevronDownBoldIcon, {
          color: "current"
        }), /*#__PURE__*/React.createElement("span", {
          className: "asc-acc-hidden"
        }, "Expand for more content")),
        className: "asc-btn--tertiary asc-grid-expand-button",
        clickHandler: this.toggleExpandDetails,
        customAttrs: {
          'aria-expanded': this.state.isExpanded,
          'aria-controls': `${rowId}-content`,
          'aria-haspopup': true
        }
      }));
    })), this.state.isExpanded && this.getExpandedContent());
  }
}
GridListRow.propTypes = propTypes;